import { Stack, Typography } from "@mui/material";
import { localize } from "@smartrr/shared/utils/sharedTranslations/localize";
import React from "react";

export const SubPlanDeleted = () => {
  return (
    <Stack direction="column" justifyContent="center" alignItems="center" textAlign="center" padding="30px 20px">
      <Typography variant="h3">
        {localize(`subscriptions.yourSubscriptions.orderOptionsModal.subPlanDeletedHeader`)}
      </Typography>
      <Typography variant="body1">
        {localize(`subscriptions.yourSubscriptions.orderOptionsModal.subPlanDeletedBody`)}
      </Typography>
    </Stack>
  );
};
